import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  constructor(protected dialogRef: NbDialogRef<ConfirmationDialogComponent>) { }

  @Input() firstMessage: string = 'Ao esvaziar o carrinho todos os produtos serão removídos!';

  @Input() secondMessage: string = 'Deseja continuar?'

  @Input() emphasisMessage: string = 'Essa ação é irreversível';

  ngOnInit(): void {
  }

  confirmSelection(status: boolean) {
    this.dialogRef.close(status);
  }

}
